import { render, staticRenderFns } from "./new-user.vue?vue&type=template&id=2307e58f"
import script from "./new-user.vue?vue&type=script&lang=js"
export * from "./new-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports